import { StyleSheet } from 'aphrodite';
import { breakpoints, layout } from '@citrite/web-ui-component';
//allow-unused-export
export const styles = StyleSheet.create({
	widgets: {
		marginBottom: '60px',
		[breakpoints.onMobile]: {
			marginLeft: '12px',
			marginTop: layout.mediumSpace,
		},
	},
	logoutButton: {
		paddingTop: '30px',
	},
});
